export default __webpack_public_path__ + "static/media/popcorn-pieces-05.383d4ae8.png";